import tools from "@/utils/tool";

export { };

export const validateUserName = (username: string) => {
  if (!tools.isString(username)) return "用户名输入类型错误";
  if (username.length < 4 || username.length > 20) return "用户名为4-20位字符";
  return undefined;
};

export const validatePassword = (password: string) => {
  if (!tools.isString(password)) return "密码输入类型错误";
  if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(password)) return "密码由字母数字组成";
  if (password.length < 6 || password.length > 15) return "密码长度为6-15位";
  return undefined;
};

export const validateConfirmPassword = (
  confirmPassword: string,
  password: string,
) => {
  if (!tools.isString(confirmPassword)) return "确认密码输入类型错误";
  if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(confirmPassword)) {
    return "确认密码由字母数字组成";
  }
  if (confirmPassword.length < 6 || confirmPassword.length > 15) {
    return "确认密码长度为6-15位";
  }
  if (confirmPassword !== password) return "两次输入密码不一致";
  return undefined;
};

export const validateImageCode = (imageCode: string) => {
  if (!tools.isString(imageCode)) return "图片验证码输入类型错误";
  if (!/^[0-9a-zA-Z]{4}$/.test(imageCode)) return "图片验证码为4位数字或字母";
  if (imageCode.length !== 4) return "图片验证码为4位数字或字母";
  return undefined;
};

export const validatePhoneNumber = (phoneNumber: string) => {
  if (!tools.isString(phoneNumber)) return "手机号码输入类型错误";
  if (!/^1[3456789]\d{9}$/.test(phoneNumber)) return "手机号码为11位数字";
  if (phoneNumber.length !== 11) return "手机号码为9位数字";
  return undefined;
};

export const validateSMSCode = (SMSCode: string) => {
  if (!tools.isString(SMSCode)) return "短信验证码输入类型错误";
  if (SMSCode.length === 0) return "短信验证码不为空";
  return undefined;
};

export const validateFileSize = (
  size: number,
  limit: number,
  unit: "KB" | "MB",
) => {
  const KB = 1024;
  const MB = 1024 * 1024;
  if (unit === "KB") {
    if (size / KB > limit) return `文件不得大于${limit}${unit}`;
  }
  if (unit === "MB") {
    if (size / MB > limit) return `文件不得大于${limit}${unit}`;
  }
};
function checkId1(code: string) {
  /**
   * 根据〖中华人民共和国国家标准 GB 11643-1999〗中有关公民身份号码的规定，公民身份号码是特征组合码，由十七位数字本体码和一位数字校验码组成。排列顺序从左至右依次为：六位数字地址码，八位数字出生日期码，三位数字顺序码和一位数字校验码。
   * 地址码表示编码对象常住户口所在县(市、旗、区)的行政区划代码。
   * 出生日期码表示编码对象出生的年、月、日，其中年份用四位数字表示，年、月、日之间不用分隔符。
   * 顺序码表示同一地址码所标识的区域范围内，对同年、月、日出生的人员编定的顺序号。顺序码的奇数分给男性，偶数分给女性。
   * 校验码是根据前面十七位数字码，按照ISO 7064:1983.MOD 11-2校验码计算出来的检验码。
   * 出生日期计算方法。
   * 15位的身份证编码首先把出生年扩展为4位，简单的就是增加一个19或18,这样就包含了所有1800-1999年出生的人;
   * 2000年后出生的肯定都是18位的了没有这个烦恼，至于1800年前出生的,那啥那时应该还没身份证号这个东东，⊙﹏⊙b汗...
   * 下面是正则表达式:
   * 出生日期1800-2099  (18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])
   * 身份证正则表达式 /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i
   * 15位校验规则 6位地址编码+6位出生日期+3位顺序号
   * 18位校验规则 6位地址编码+8位出生日期+3位顺序号+1位校验位
   * 校验位规则     公式:∑(ai×Wi)(mod 11)……………………………………(1)
   * 公式(1)中：
   * i----表示号码字符从由至左包括校验码在内的位置序号；
   * ai----表示第i位置上的号码字符值；
   * Wi----示第i位置上的加权因子，其数值依据公式Wi=2^(n-1）(mod 11)计算得出。
   * i 18 17 16 15 14 13 12 11 10 9 8 7 6 5 4 3 2 1
   * Wi 7 9 10 5 8 4 2 1 6 3 7 9 10 5 8 4 2 1
   * ============================================================================================
   * 身份证号合法性验证
   * 支持15位和18位身份证号
   * 支持地址编码、出生日期、校验位验证
   * @param code
   * @returns {*[]} 该函数返回一个数组 [true,''] 或 [false,"身份证号格式错误"]
   * @constructor
   */
  function IdentityCodeValid(code: string) {
    var city: Record<string | number, string> = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江 ",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外 ",
    };
    var tip = "";
    var pass = true;

    if (
      !code ||
      !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/i
        .test(
          code,
        )
    ) {
      tip = "身份证号格式错误";
      pass = false;
    } else if (!city[code.substring(0, 2)]) {
      tip = "地址编码错误";
      pass = false;
    } else {
      //18位身份证需要验证最后一位校验位
      if (code.length === 18) {
        let _code = code.split("");
        //∑(ai×Wi)(mod 11)
        //加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        //校验位
        var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
        var sum = 0;
        var ai = 0;
        var wi = 0;
        for (var i = 0; i < 17; i++) {
          ai = +_code[i];
          wi = factor[i];
          sum += ai * wi;
        }
        var last = parity[sum % 11];
        if (`${last}` !== `${_code[17]}`) {
          tip = "校验位错误,结尾是字母请注意大小写";
          pass = false;
        }
      }
    }
    // if(!pass) alert(tip);
    //return pass;
    return [pass, tip];
  }

  return IdentityCodeValid(code)[0];
}

function checkId2(code: string) {
  /**
   * 验证身份证号码
   * @param { String } code 身份证号码
   */
  function identityIDCard(code: string) {
    // 身份证号前两位代表区域
    const city: Record<number | string, string> = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江 ",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外 ",
    };
    const idCardReg =
      /^[1-9]\d{5}(19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i; // 身份证格式正则表达式
    let errorMessage = ""; // 错误提示信息
    let isPass = true; // 身份证验证是否通过（true通过、false未通过）

    // 如果身份证不满足格式正则表达式
    if (!code) {
      errorMessage = "请输入身份证号码";
      isPass = false;
    } else if (!code.match(idCardReg)) {
      errorMessage = "请输入正确的身份证号码";
      isPass = false;
    } else if (!city[code.substring(0, 2)]) {
      // 区域数组中不包含需验证的身份证前两位
      errorMessage = "请输入正确的身份证号码";
      isPass = false;
    } else if (code.length === 18) {
      // 18位身份证需要验证最后一位校验位
      let _code = code.split("");
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      // 校验位
      const parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
      let sum = 0;
      let ai = 0;
      let wi = 0;
      for (let i = 0; i < 17; i++) {
        ai = parseInt(_code[i]);
        wi = factor[i];
        sum += ai * wi; // 开始计算并相加
      }
      const last = parity[sum % 11]; // 求余
      if (last.toString() !== `${_code[17]}`) {
        errorMessage = "请输入正确的身份证号码";
        isPass = false;
      }
    }
    return {
      errorMessage,
      isPass,
    };
  }

  return identityIDCard(code).isPass;
}

export function checkIDCard(idcode: string) {
  // 加权因子
  var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  // 校验码
  var check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];

  var code = idcode + "";
  var last = idcode[17]; //最后一位

  var seventeen = code.substring(0, 17);

  // ISO 7064:1983.MOD 11-2
  // 判断最后一位校验码是否正确
  var arr: string[] | number[] = seventeen.split("");
  var len = arr.length;
  var num = 0;
  for (var i = 0; i < len; i++) {
    num = num + +arr[i] * weight_factor[i];
  }

  // 获取余数
  var resisue = num % 11;
  var last_no = check_code[resisue];

  // 格式的正则
  // 正则思路
  /*
  第一位不可能是0
  第二位到第六位可以是0-9
  第七位到第十位是年份，所以七八位为19或者20
  十一位和十二位是月份，这两位是01-12之间的数值
  十三位和十四位是日期，是从01-31之间的数值
  十五，十六，十七都是数字0-9
  十八位可能是数字0-9，也可能是X
  */
  var idcard_patter =
    /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

  // 判断格式是否正确
  var format = idcard_patter.test(idcode);
  // console.log(last, last_no, format);
  // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
  return (
    (last === last_no && format ? true : false) ||
    checkId1(idcode) ||
    checkId2(idcode)
  );
}
